//Componentes generales
import React, { useState, useEffect } from "react";
import moment from "moment";

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from '../../utils/priority';

//Permisos
import { EDITAR_NOTAS_PRIVADAS } from "../../utils/permisos";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark,
    faBox,
    faRotateRight,
    faFilePdf,
    faDownload,
    faPen,
    faRectangleXmark,
    faFloppyDisk
} from "@fortawesome/free-solid-svg-icons";

//Estilos
import './ReqInfo.css';

/* 
    Componente encargado de mostrar el detalle del requerimiento.
        Donde item es el requerimiento seleccionado.
              files son los archivos adjuntados al requerimiento.
              cerrar es la función encargada de ocultar el dialogo.
              verDetalle es la función del context que recupera los productos del requerimiento.
              repetir es una función que llama al componente que corresponda.
              generaPDF es una función que llama al componente que corresponda.
              abrirURL es la función encargada de abrir en una nueva ventana el archivo seleccionado.
              guardarModificaciones es la función del context que guarda el requerimiento en el caso de haber modificaciones.
              usuario es el usuario en sesión.

*/
function ReqInfo({ item = {}, files, cerrar, verDetalle, repetir, generaPDF, abrirURL, guardarModificaciones, usuario }) {

    //state de productos.
    const [products, setProducts] = useState([]);
    //state de requerimiento.
    const [requerimiento, setRequerimiento] = useState(item);
    //state para edición de nota.
    const [editNota, setEditNota] = useState(false);
    //state para edición de nota privada.
    const [editNotaReservada, setEditNotaReservada] = useState(false);
    //state para edición de prioridad.
    const [editPrioridad, setEditPrioridad] = useState(false);
    //state para indicar nota ya editada.
    const [editadoNota, setEditadoNota] = useState(false);
    //state para indicar nota reservada ya editada.
    const [editadoNotaReservada, setEditadoNotaReservad] = useState(false);

    /*
        Al renderizar el componente, recupera los productos del requerimiento seleccionado.
    */
    useEffect(() => {
        async function fp() {
            try {
                const p = await verDetalle(item.tDocCodFor, item.tDocNroFor);
                setProducts(p);
            } catch (error) {
                console.log("error");
            }
        }
        fp();
    }, []);

    /*
        Disparador que se activa al detectar algun cambio en el item. Setea el requerimiento con el item que fue modificado.
    */
    useEffect(() => {
        setRequerimiento(item);
    }, [item]);

    /*
        Manejador que descargar/abre todos los archivos adjuntados al requerimiento. 
    */
    const handleDownloadAll = () => {
        files.map((file) => (abrirURL(file.url)));
    }

    /* 
        Manejador que determina si habilitar o no la edición del campo Nota.
    */
    const handleEditNota = () => {
        setEditNota(!editNota);
    }

    /* 
        Manejador que determina si habilitar o no la edición del campo Nota Reservada.
    */
    const handleEditNotaReservada = () => {
        setEditNotaReservada(!editNotaReservada);
    }

    /* 
        Manejador que determina si habilitar o no la edición de la prioridad.
    */
    const handleEditPrioridad = () => {
        setEditPrioridad(!editPrioridad);
    }

    /* 
        Manejador ante cambio en casilla de Nota.
            Donde valor es lo ingresado por el usuario.
    */
    const handleModificaNota = (valor) => {
        setRequerimiento({ ...requerimiento, notePubl: valor });
        setEditadoNota(true);
    }

    /* 
        Manejador ante cambio en casilla de Nota Reservada.
            Donde valor es lo ingresado por el usuario.
    */
    const handleModificaNotaReservada = (valor) => {
        setRequerimiento({ ...requerimiento, notePriv: valor });
        setEditadoNotaReservad(true);
    }

    /* 
        Manejador ante cambio en la prioridad.
            Donde valor es lo seleccionado por el usuario.
    */
    const handleModificaPrioridad = (valor) => {
        const req_temp = { ...requerimiento, priority: valor };
        setRequerimiento(req_temp);
        setEditPrioridad(false);
        guardarModificaciones(req_temp, {priority: valor});
    }

    /* 
        Guarda el requerimiento mediante función del context.
    */
    const saveChanges = async () => {
        setEditNota(false);
        setEditNotaReservada(false);
        setEditPrioridad(false);
        let obj = {};
        if(editadoNota){
            obj = {notePubl: requerimiento.notePubl}
        }
        if(editadoNotaReservada){
            obj = {notePriv: requerimiento.notePriv}
        }

        const resp = await guardarModificaciones(requerimiento, obj);
        setRequerimiento(resp);
    }

    return (
        <div className='container-gr-req'>
            <div className='container-r-list-item-header-info'>
                <div className='label-req'>{requerimiento.tDocCodFor + ' - ' + requerimiento.tDocNroFor}</div>
                <div className='r-list-item-header-title'>{requerimiento.title}</div>
                {/* <div className={requerimiento.priority === 0 ? 'r-list-item-header-priority-media margin-right-r' : requerimiento.priority === 1 ? 'r-list-item-header-priority-alta margin-right-r' : 'r-list-item-header-priority-urgente margin-right-r'}>{PRIORITYOUT[requerimiento.priority]}</div> */}
                <div className='container-prioritys-gral'>
                    <div className={requerimiento.priority === 2 ? 'r-list-item-header-priority-urgente  margin-right-r' : requerimiento.priority === 1 ? 'r-list-item-header-priority-alta  margin-right-r' : 'r-list-item-header-priority-media  margin-right-r'} onClick={handleEditPrioridad}>
                        {PRIORITY[requerimiento.priority ? requerimiento.priority : 0]}
                    </div>
                    {editPrioridad &&
                        <div className='options-container-reqinfo' >
                            <div className='options-container-fr-back'>
                                {PRIORITY.map((prior) => {
                                    return (
                                        <div key={prior} className={PRIORITYIN[prior] === 2 ? 'r-list-item-header-priority-urgente' : PRIORITYIN[prior] === 1 ? 'r-list-item-header-priority-alta' : 'r-list-item-header-priority-media'} value={prior} onClick={() => handleModificaPrioridad(PRIORITYIN[prior])}>{prior}</div>
                                    );
                                })}
                            </div>
                        </div>
                    }
                </div>

                <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faXmark} onClick={() => cerrar(null)} />
            </div>
            <div className='container-r-item-details'>
                <div className='container-r-info-p'>
                    <div className='label-req-title'>Estado Actual </div><div className='r-list-item-details-clave-v'>{requerimiento.state}</div>
                    <div className='label-req-title'>Emitido por </div><div className='r-list-item-details-title-v'>{requerimiento.userName}</div>
                </div>
                <div className='container-r-item-title-details'>Info Adicional</div>
                <div className='container-r-texto'>
                    <div className='r-list-item-details-data-v'>{requerimiento.observ}</div>
                </div>
                <div className='container-r-item-title-details'>Fecha</div>
                <div className='container-r-fecha'>
                    <div className='label-req-fecha'><div className='r-list-item-details-data-v'>Alta </div><div className='r-list-item-details-fecha-v'>{moment(requerimiento.fecAlt).format('DD-MM-YYYY')}</div></div>
                    <div className='label-req-fecha'><div className='r-list-item-details-data-v'>Entrega </div><div className='r-list-item-details-fecha-v'>{moment(requerimiento.deliveryDate).format('DD-MM-YYYY')}</div></div>
                </div>
                <div className='container-r-item-title-details'>Items: {requerimiento.quantity}</div>
                <div className="container-list-products-r-gral">
                    {products.map((product) => {
                        return (
                            <div className="container-list-products-r" key={product.codRed}>
                                <div className="container-list-product-r-icon">
                                    <div className='list-item-icon-r'><FontAwesomeIcon icon={faBox} /></div>
                                    <div className="list-item-title-r">
                                        {product.codRed}
                                    </div>
                                </div>
                                <div className="container-list-products-r-details">
                                    <div>
                                        {product.descrp}
                                    </div>
                                    <div>
                                        {product.textAdic}
                                    </div>
                                    <div className="container-cantidad-product-r">
                                        Cantidad: {product.quantity}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='container-r-item-title-details'>
                    <div>Nota</div>
                    {!editNota &&
                        <div className='container-button-download'><button className="button-edit" onClick={handleEditNota}><FontAwesomeIcon icon={faPen} /> </button></div>
                    }
                    {editNota &&
                        <div className='container-button-download'>
                            <button className="button-edit" onClick={handleEditNota}><FontAwesomeIcon icon={faRectangleXmark} /></button>
                            <button className="button-edit" onClick={saveChanges}><FontAwesomeIcon icon={faFloppyDisk} /></button>
                        </div>
                    }

                </div>
                <div className='container-r-texto'>
                    {!editNota &&
                        <div className='r-list-item-details-data-v'>{requerimiento.notePubl}</div>
                    }
                    {editNota &&
                        <textarea className='r-textarea-input' value={requerimiento.notePubl} onChange={(data) => handleModificaNota(data.target.value)} />
                    }
                </div>
                {usuario.userType.some(item => EDITAR_NOTAS_PRIVADAS.includes(item.typeName)) && (
                    <>
                        <div className='container-r-item-title-details'>
                            <div>Nota Reservada</div>
                            {!editNotaReservada &&
                                <div className='container-button-download'><button className="button-edit" onClick={handleEditNotaReservada}><FontAwesomeIcon icon={faPen} /> </button></div>
                            }
                            {editNotaReservada &&
                                <div className='container-button-download'>
                                    <button className="button-edit" onClick={handleEditNotaReservada}><FontAwesomeIcon icon={faRectangleXmark} /></button>
                                    <button className="button-edit" onClick={saveChanges}><FontAwesomeIcon icon={faFloppyDisk} /></button>
                                </div>
                            }
                        </div>
                        <div className='container-r-texto'>
                            {!editNotaReservada &&
                                <div className='r-list-item-details-data-v'>{requerimiento.notePriv}</div>
                            }
                            {editNotaReservada &&
                                <textarea className='r-textarea-input' value={requerimiento.notePriv} onChange={(data) => handleModificaNotaReservada(data.target.value)} />
                            }
                        </div>
                    </>
                )}
                <div className='container-r-item-title-details'>
                    <div>Archivos</div>
                    <div className='container-button-download'><button className="button-download" onClick={handleDownloadAll}>Descargar Todos <FontAwesomeIcon icon={faDownload} /> </button></div>
                </div>
                <div className='container-files-rq'>
                    <ul className='container-files-rq-details'>
                        {files.map((file) => (
                            <li className="container-files-rq-details-items" key={file.name} onClick={() => abrirURL(file.url)}>{file.name}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="rq-container-buttons-bottom">
                <div className="rq-button-bottom" onClick={() => generaPDF(requerimiento, 'Admin')} ><FontAwesomeIcon icon={faFilePdf} /> PDF</div>
                <div className="rq-button-bottom" onClick={() => repetir(requerimiento, products)} ><FontAwesomeIcon icon={faRotateRight} /> Repetir</div>
            </div>
        </div>
    );
}

export default ReqInfo